import { createSlice } from '@reduxjs/toolkit';
import { authInitialState as initialState } from '../initialStates/authInitialState';

function pickUser(u) {
  if (!u) return null;
  const { uid, email, displayName, photoURL, phoneNumber, providerData } = u;
  return { uid, email, displayName, photoURL, phoneNumber, providerData };
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthUser(state, action) {
      state.user = pickUser(action.payload);
      state.loading = false;
    },
    setAuthLoading(state, action) {
      state.loading = !!action.payload;
    },
    clearAuthUser(state) {
      state.user = null;
      state.loading = false;
    }
  }
});

export const { setAuthUser, setAuthLoading, clearAuthUser } = authSlice.actions;
export const selectAuthUser = (state) => state.auth.user;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectIsAuthenticated = (state) => !!state.auth.user;
export default authSlice.reducer;
